import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";

export const LocationContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  width: 250px;
`;

export const LocationClickable = styled(Button)`
  padding: 0;
  display: block;
  text-align: left;
  text-transform: none;
`;

export const MapImage = styled("img")`
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
`;

export const PlaceName = styled(Box)`
  padding: 8px 4px;
`;
